(() => {
  if (window.__hieugklCoreReady) return;
  window.__hieugklCoreReady = true;
  const focusBefore = new WeakMap();
  function showFormula(id, trigger) {
    const dialog = document.getElementById(id);
    if (!(dialog instanceof HTMLDialogElement)) return false;
    focusBefore.set(dialog, trigger || document.activeElement);
    if (!dialog.open) dialog.showModal();
    return true;
  }
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-hkl-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && /^#formula-(garlic|quercetin|probiotic)$/.test(url.hash)) {
      if (showFormula(url.hash.slice(1), link)) event.preventDefault();
    }
    const menu = link.closest('[data-hkl-menu]');
    if (menu) menu.removeAttribute('open');
  });
  function setupDialogs() {
    document.querySelectorAll('.hkl-dialog').forEach(dialog => {
      if (dialog.dataset.hklReady) return;
      dialog.dataset.hklReady = 'true';
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => focusBefore.get(dialog)?.focus());
    });
    if (/^#formula-(garlic|quercetin|probiotic)$/.test(location.hash)) showFormula(location.hash.slice(1));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupDialogs); else setupDialogs();
  document.addEventListener('shopify:section:load', setupDialogs);
})();
